import CollapsibleSection from './CollapsibleSection';

export default CollapsibleSection;
export { primitives as CollapsibleSectionPrimitives } from './CollapsibleSection';
